<app-dialog-header (clickEvent)="dialogService.dismissActiveModal('close')">
   {{ 'asm.usersSalesNote' | cxTranslate }}
</app-dialog-header>
<div
   class="siko-dialog-body mt-24 sales-note-content">
   {{ formattedSalesNote() }}
</div>
